<div class="order-summery w-100">
  <div [ngClass]="{'main-items-container': isContentVisible, 'main-items-container-non-scroll': !isContentVisible}"
       class="main-items-container">
    <div class="sum-products w-100">
      <div class="order-summery-mob w-100 non-visible-os">
        <div class="order-summery-mob-row" (click)="toggleContentVisibility()">
          <div class="osm-row-p1">
            <img src="assets/shipping-address/shoppingCart.svg" alt="Shopping Cart" class="osm-row-p1">
          </div>
          <span class="osm-row-p2">Order Summary</span>
          <div class="osm-row-p1">
            <img src="assets/shipping-address/navigationUp.svg" alt="Navigation Image"
                 [ngClass]="{'osm-row-p3-rotated': !isContentVisible, 'osm-row-p3': isContentVisible}">
          </div>
        </div>
      </div>
      @if (isContentVisible) {
        <div class="sum-main-title">
          <div class="smt-product"><span class="smp-prod-value">{{ 'cart.product' | translate }}</span></div>
          <div class="smt-price"><span class="smp-color-value">{{ 'cart.color' | translate }}</span></div>
          <div class="smt-subtotal"><span class="smp-price-value">{{ 'cart.price' | translate }}</span></div>
        </div>
        @for (cart of allCarts; track cart) {
          <div class="sum-product-items">
            <div class="spi-product">
              <div class="spi-product-img">
                <img [src]="getProductImageUrl(cart.product.imageUrls[0])"  alt="Product image" class="spi-img">
                <label class="img-qty">{{ cart.quantity }}</label>
              </div>
              <span class="spi-product-name">
              {{ cart.product.productName }}
            </span>
            </div>
            <div class="spi-product-color">
              <label class="color-eli" [style.background-color]="cart.selectedColor"></label>
            </div>
            <div class="spi-product-price">
              <span class="spi-price-inline">${{ cart.priceUSD | number:'1.1-1'}} / {{ cart.priceAMD | number:'1.1-1'}} {{'subscription_plan_content.AMD' | translate }}</span>
            </div>
          </div>
        }
      }
    </div>
  </div>
  @if (isContentVisible && !payment) {
    <div class="sum-content">
      <mat-divider></mat-divider>
      <div class="common-final-row w-100">
        <span class="common-row-t1">{{ 'cart.total' | translate }}</span>
        <span class="common-final-row-t2 ms-2">${{ totalSumUsd | number:'1.1-1'}} / {{ (totalSumAmd | number:'1.1-1') + ' ' }}{{'subscription_plan_content.AMD' | translate }}</span>
      </div>
    </div>
  } @else if (isContentVisible && payment) {
    <form>
      <div class="sum-field">
        <app-filled-form-field
          [formControl]="promoCodeControl"
          [isControlInvalid]="promoCodeControl.invalid && (promoCodeControl.touched || promoCodeControl.dirty)"
          [errorMessage]="getPromoCodeErrorMessageByValidatorName"
          class="w-100" label="{{ 'payment.promo_code_messages' | translate}}">
         </app-filled-form-field>
        <button class="sum-field-button" (click)="onApplyPromoCode()">{{ 'payment.apply' | translate }}</button>
      </div>
    </form>
    <div class="sum-content">
      <div class="common-row w-100">
        <span class="common-row-t1">{{ 'payment.subtotal' | translate}}</span>
        <span class="dropdown__price">${{ totalSumUsd | number:'1.1-1'}} / {{ (totalSumAmd | number) + ' ' }}{{'subscription_plan_content.AMD' | translate }}</span>
      </div>
      <label class="common-line"></label>
      <div class="common-row common-row--shipping w-100">
        <span class="common-row-t1">{{ 'payment.shipping' | translate }}</span>
        <span class="common-row-t2">{{ (deliveryMethod == ShippingType.STANDARD ? 'shipping-method.free' : 'shipping-method.express') | translate }}</span>
      </div>
      <label class="common-line"></label>
      <div class="common-final-row w-100">
        <span class="common-row-t1">{{ 'payment.total' | translate }}</span>
        <span class="common-final-row-t2">${{ calculatedSumUsd | number:'1.1-1'}} / {{ (calculatedSumAmd | number:'1.1-1') + ' ' }}{{'subscription_plan_content.AMD' | translate }}</span>
      </div>
    </div>
  }
</div>
